import request from '@/utils/request'

// 产品分类
export const getRouters = (productId) => {
  return request({
    url: '/home/routers'
  })
}

// 判断是否为超管
export const getIsAdmin = () => {
  return request({
    url: '/home/isAdmin'
  })
}
